import { useLocalization } from "@fluent/react";
import { useObjectMemo } from "byzantine";

/**
 * Localized strings for dnd-kit drag-and-drop accessibility announcements.
 * The returned functions can be passed to `<DndContext accessibility={{ announcements }}>`
 * to accommodate screen readers.
 */
const useDragAnnouncementLabels = () => {
  const { l10n } = useLocalization();

  return useObjectMemo({
    dragPickedUp: (label: string) =>
      l10n.getString("drag-picked-up", { label }),
    dragMoving: (activeLabel: string, overLabel: string) =>
      l10n.getString("drag-moving", { activeLabel, overLabel }),
    dragDroppedOn: (activeLabel: string, overLabel: string) =>
      l10n.getString("drag-dropped-on", { activeLabel, overLabel }),
    dragDropped: (label: string) => l10n.getString("drag-dropped", { label }),
    dragCancelled: (label: string) =>
      l10n.getString("drag-cancelled", { label }),
    itemFallback: l10n.getString("drag-item-fallback"),
  });
};

export default useDragAnnouncementLabels;
